import NavigationsPage from "@containers/NavigationsPage/NavigationPage"
import PageWrapper from "@components/Common/PageWrapper"
import styles from "./DashBoardPage.module.css"
import TimeAppointments from "@components/ManageAppointmentPage/TimeAppointments"
import AppointmentCalendar from "../ManageAppointmentPage/AppointmentCalendar"
import ArrowSquareLeftIcon from "@assets/icons/arrowSquareLeft"
import DoctorIntro from "@components/DashboardPage/DoctorIntro"
import PatientStats from "@components/DashboardPage/PatientStats"
import UpcomingAppointments from "@components/DashboardPage/UpcomingAppointments"
import OtherApplications from "@components/DashboardPage/OtherApplications"
import ForAnyAssistance from "@components/DashboardPage/ForAnyAssistance"
import SharePatientWebsite from "@components/DashboardPage/SharePatientWebiste"
import usePatient from "@hooks/usePatient"
import useBooking from "@hooks/useBooking"
import { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import ApiLoader from "@components/Common/ApiLoader"
import GoBack from "@components/Common/GoBack"
function DashBoardPage() {
  const { handleGetPatientCount } = usePatient()
  const { isGetUpcomingBookingLoading, isGetCalendarBookingLoading } =
    useSelector((state) => state.booking)
  const { isGetPatientCountLoading } = useSelector((state) => state.patient)
  const { handleGetUpcomingBooking, handleGetCalendarBooking } = useBooking()
  const [selectedDate, setSelectedDate] = useState(() => {
    const currentDate = new Date()
    return currentDate
  })
  useEffect(() => {
    handleGetPatientCount()
    handleGetUpcomingBooking()
  }, [
    handleGetPatientCount,
    handleGetUpcomingBooking,
    handleGetCalendarBooking,
  ])
  useEffect(() => {
    handleGetCalendarBooking({ date: selectedDate.toISOString() })
  }, [selectedDate, handleGetCalendarBooking])

  const handleCalendarDateChange = (value) => {
    setSelectedDate(value)
  }
  return (
    <>
      <NavigationsPage>
        <PageWrapper className={styles.manageAppointmentPage}>
          <div className="text-sm md:text-3xl font-bold text-[--primary-blue] md:text-[--quaternary-black] md:font-normal mb-5 md:mb-8">
            <GoBack className="mb-5 md:hidden">
              <ArrowSquareLeftIcon />
            </GoBack>

            <h2>Dashboard</h2>
          </div>
          {/* Changed from sm:flex-row to xl:flex-row and updated other breakpoints */}
          <div className="flex flex-col xl:flex-row gap-2 md:gap-5 h-min md:justify-normal w-full max-w-[22rem] m-auto md:max-w-none md:m-0">
            <div className="grow xl:overflow-x-hidden h-max gap-2 md:gap-5 flex flex-col max-w-[66rem]">
              <DoctorIntro />
              <div className="flex flex-col md:flex-row max-w-[22rem] md:max-w-none gap-2 md:gap-5">
                <PatientStats />
                <UpcomingAppointments />
              </div>
              <div className="hidden md:flex md:flex-row max-w-[22rem] md:max-w-none gap-2 md:gap-5">
                <div className="flex flex-col gap-2 md:gap-5 md:max-w-[20.12rem]">
                  <ForAnyAssistance headingText="For any assistance" />
                  <SharePatientWebsite />
                </div>

                <OtherApplications />
              </div>
            </div>
            <div className={`flex flex-col gap-4 md:flex grow max-w-96`}>
              <AppointmentCalendar
                rootClassNameOnCollapsed="md:min-h-[14.8rem]"
                onChange={handleCalendarDateChange}
                disablePastDates={false}
              />

              <TimeAppointments rootClassName="max-h-[32.5rem]" />
            </div>
            <div className="md:hidden flex flex-col max-w-[22rem] md:max-w-none gap-2 md:gap-5">
              <OtherApplications />
              <div className="flex flex-col gap-2 md:gap-5 md:max-w-[20.12rem]">
                <ForAnyAssistance headingText="For any assistance" />
                <SharePatientWebsite />
              </div>
            </div>
          </div>
        </PageWrapper>
      </NavigationsPage>

      {isGetPatientCountLoading ||
      isGetCalendarBookingLoading ||
      isGetUpcomingBookingLoading ? (
        <ApiLoader />
      ) : null}
    </>
  )
}

export default DashBoardPage
